import * as React from 'react';
import { cn } from '../lib/utils';

export interface StaticTooltipProps extends Omit<
  React.HTMLAttributes<HTMLDivElement>,
  'title'
> {
  title: React.ReactNode;
}

const StaticTooltip = React.forwardRef<HTMLDivElement, StaticTooltipProps>(
  ({ className, title, children, style, ...props }, ref) => {
    const tooltipId = React.useId();
    return (
      <div ref={ref} className="relative inline-block" {...props}>
        <div
          id={tooltipId}
          role="tooltip"
          className={cn(
            'absolute z-50 rounded-md border bg-white px-2.5 py-1.5 text-sm shadow-md',
            className,
          )}
          style={{
            top: '-60px',
            left: '-50%',
            ...style,
          }}
        >
          {title}
        </div>
        <div aria-describedby={tooltipId}>{children}</div>
      </div>
    );
  },
);
StaticTooltip.displayName = 'StaticTooltip';

export { StaticTooltip };
